import { useIntl } from 'react-intl';
import { useMediaQuery, useTheme } from '@mui/material';
import { useReactiveVar } from '@apollo/client';

import { Box } from '../../../common/box';
import { Stepper } from '../../../common/stepper';
import { useRegistrationSteps } from './registration.steps';
import { IRegistrationProps } from './registration.models';
import { ErrorAuth } from './error-auth/error-auth';
import { useStyles } from './registration.styles';
import { Page } from '../page/page';
import { setCaptcha } from '../../../../graphql/configuration/configuration.cache';
import { CaptchaType } from '../../../../graphql/configuration';

export const Registration = ({ onDone, externalState }: IRegistrationProps): JSX.Element => {
  const intl = useIntl();
  const registrationSteps = useRegistrationSteps();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const classes = useStyles();
  const captcha = useReactiveVar(setCaptcha);

  return (
    <Page
      title={intl.formatMessage({ id: 'registrationPage.title' })}
      description={intl.formatMessage({ id: 'registrationPage.description' })}
      pageScript={captcha?.type === CaptchaType.reCaptcha ? process.env.REACT_APP_RECAPTCHA_API_URL : undefined}
    >
      <div className={classes.errorWrapper}>
        {!isMobile && <ErrorAuth textId="registration.phoneStep.error.existing" rootStyles={classes.error} />}
      </div>
      <Box externalRootClasses={classes.box}>
        <Stepper
          steps={registrationSteps}
          onDone={onDone}
          externalState={externalState}
        />
      </Box>
    </Page>
  );
};
